import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X, ArrowUpRight } from "lucide-react";
import { Logo } from "./Logo";

const LINKS = ["services", "roofing", "projects", "about", "contact"];

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.9, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-500 ${scrolled ? "border-b border-white/10 bg-[#090B0E]/80 backdrop-blur-xl" : "bg-transparent"}`}
    >
      <nav className="mx-auto flex max-w-7xl items-center justify-between px-5 py-4 sm:px-8 lg:px-12">
        <Logo />
        <div className="hidden items-center gap-9 md:flex">
          {LINKS.map((l) => (
            <a key={l} href={`#${l}`} data-testid={`navbar-link-${l}`} className="nav-link font-mono text-xs uppercase tracking-[0.2em] text-slate-300 hover:text-white">
              {l}
            </a>
          ))}
        </div>
        <div className="hidden md:block">
          <a href="#contact" data-testid="navbar-quote-cta-button" className="btn-primary">
            Get a Quote <ArrowUpRight className="h-4 w-4" />
          </a>
        </div>
        <button data-testid="navbar-mobile-toggle" onClick={() => setOpen(!open)} className="p-2 text-white md:hidden" aria-label="Menu">
          {open ? <X /> : <Menu />}
        </button>
      </nav>
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ height: 0 }}
            animate={{ height: "auto" }}
            exit={{ height: 0 }}
            className="overflow-hidden border-t border-white/10 bg-[#090B0E] md:hidden"
          >
            <div className="flex flex-col px-5 py-6">
              {LINKS.map((l) => (
                <a key={l} href={`#${l}`} onClick={() => setOpen(false)} data-testid={`mobile-link-${l}`} className="border-b border-white/10 py-4 font-display text-3xl font-bold uppercase text-white">
                  {l}
                </a>
              ))}
              <a href="#contact" onClick={() => setOpen(false)} data-testid="mobile-quote-cta" className="btn-primary mt-6 justify-center">Get a Quote</a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  );
};
